module.exports = __webpack_public_path__ + "static/media/kontakt_banner.0c6acabe.jpg";